import { Flex, Skeleton } from "@mantine/core";
import styles from "./MemberDirectory.module.css";

/** Linhas da lista "Equipe" (avatar, nome e e-mail, selo do perfil). */
export function DirectoryRowsSkeleton({ rows = 5 }: { rows?: number }) {
  return (
    <>
      {Array.from({ length: rows }).map((_, index) => (
        <Flex
          key={index}
          align="center"
          gap={12}
          px={20}
          py={12}>
          <Skeleton
            circle
            height={36}
          />
          <Flex
            direction="column"
            gap={6}
            flex={1}>
            <Skeleton
              height={12}
              width="60%"
            />
            <Skeleton
              height={10}
              width="80%"
            />
          </Flex>
          <Skeleton
            height={18}
            width={52}
            radius="xl"
          />
        </Flex>
      ))}
    </>
  );
}

/**
 * Esqueleto da aba de membros inteira, no formato do `MemberDirectory`: os
 * títulos fixos aparecem como texto e só as regiões de dado viram esqueleto.
 */
export function MemberDirectorySkeleton() {
  return (
    <div className={styles.root}>
      <section className={styles.list}>
        <div className={styles.listHeader}>
          <div className={styles.titleRow}>
            <div className={styles.titleBlock}>
              <div className={styles.title}>Equipe</div>
              <Skeleton
                height={12}
                width={80}
                mt={4}
              />
            </div>
            <Skeleton
              height={30}
              width={90}
              radius="sm"
            />
          </div>
          <Skeleton
            height={40}
            radius="md"
          />
        </div>
        <DirectoryRowsSkeleton />
      </section>
      <div className={styles.empty} />
    </div>
  );
}
